import React from "react";
import {connect} from "react-redux";
import { Field, reduxForm } from "redux-form";
import { database } from "../app-database";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Modal from '../generalcomponets/modal-mobile';

const mapState = (state) => {
	return {
		preguntas1: state.catalogos.catalogoPregunta1,
		preguntas2: state.catalogos.catalogoPregunta2
	};
};

const mapDispatch = (dispatch) => {
	return {
		llenarPreguntas: (cat1, cat2) =>{
			dispatch({ "type": "CARGAR_CATALOGO_PREGUNTAS", catalogoPregunta1: cat1, catalogoPregunta2: cat2});
		}
	};
};

const validate = values => {
	const errors = {};
	
	if (!values.password) {
		errors.password = "Campo requerido.";
	} else if(/\s+/.test(values.password)){
		errors.password = "No se admiten espacios en blanco.";
	} else if (values.password.length <= 7) {
		errors.password = "Debe ser al menos de 8 posiciones.";
	} else if (values.password.toLowerCase().includes("gnp")) {
		errors.password = "No debe contener la palabra GNP.";
	} else if (!/^[a-z0-9]+$/i.test(values.password)) {
		errors.password = "No debe contener caracteres especiales.";
	} else if (isNaN(values.password) == false) {
		errors.password = "Debe incluir caracteres alfabéticos.";
	} else if (/[0-9]/.test(values.password) == false) {
		errors.password = "Debe contener al menos un carácter numérico.";
	} else if(/([\w])\1{2,}/.test(values.password)) {
		errors.password = "No debe contener más de dos caracteres de de forma consecutiva (222, eee).";
	} else if(!/[A-Z]/.test(values.password)){
		errors.password = 'Debe contener al menos una mayúscula.'
	} else {
		let ABC = "abcdefghijklmnopqrstuvwxyz", NUMEROS = "0123456789";
		for(var i = 0; i < values.password.length; i++) {
			var cadena = values.password.substr(i,3).toLowerCase();
			if(cadena.length == 3 && (ABC.indexOf(cadena) >= 0 || NUMEROS.indexOf(cadena) >= 0)) {
				errors.password = "No debe contener más de dos caracteres de forma consecutiva (123, abc).";
				break;
			}
		}
	}
	
	if (!values.confpassword) {
		errors.confpassword = "Campo requerido.";
	} else if(values.confpassword != values.password) {
		errors.confpassword = "Tus contraseñas no coinciden. Favor de verificar.";
	}
	
	if (!values.pregunta1 || values.pregunta1 == 0) {
		errors.pregunta1 = "Campo requerido.";
	}
	
	if (!values.respuesta1) {
		errors.respuesta1 = "Campo requerido.";
	} else  if (values.respuesta1==values.respuesta2) {
		errors.respuesta1 = "Tus respuestas no deben ser iguales. Favor de verificar.";
	}
	
	if (!values.pregunta2 || values.pregunta2 == 0) {
		errors.pregunta2 = "Campo requerido.";
	}
	
	if (!values.respuesta2) {
		errors.respuesta2 = "Campo requerido.";
	} else if(values.respuesta1==values.respuesta2) {
		errors.respuesta2 = "Tus respuestas no deben ser iguales. Favor de verificar.";
	}

	return errors;
};

const espacios = tipo => (value, campos) => {
	let texto = (value != undefined && value != " ")? value : "";
	texto = texto.replace(/\s{2,}/g, " ");
	//texto = texto.replace(/^\s*|\s*$/g,"");
	
	campos[tipo] = texto;
};

const campoSettings = {
	fontFamily:'Roboto',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
};

const floatingLabelStyleSettings = {
	...campoSettings,
	lineHeight: '24px',
	letterSpacing: '0.5px',
	color: '#33445F',
};

const floatingLabelFocusStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.4px',
	color: '#FF6B0B',
};

const campo = ({ input, label, type, param, max, fnToggle, clase, meta: { touched, error } }) => {
	return (
		<MuiThemeProvider>
			<TextField
				floatingLabelText={label}
				fullWidth={true}
				underlineStyle={{ borderColor: '#AAC3EE'}}
				underlineFocusStyle={{borderColor: '#FF6B0B'}}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				onFocus={focus}
				onChange={(event) => {input.onChange(event); }}
				maxLength={max}
				errorText={touched && error}
			/>
		</MuiThemeProvider>
	);
};

const campoSelect = ({ input, label, type, blur, change, name, meta: { touched, error }, children, ...custom }) => {
	return (
		<MuiThemeProvider>
			<SelectField
				{...input}
				name={name}
				floatingLabelText={label}
				underlineStyle={{borderColor: '#AAC3EE'}}
				underlineFocusStyle={{borderColor: '#FF6B0B'}}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				onChange={(event, index, value) => { input.onChange(value); }}
				children={children}
				fullWidth={true}
				errorText={touched && error}
				{...custom}
			/>
		</MuiThemeProvider>
	);
};


class SeguridadForm extends React.Component{
	
	componentWillMount = () => {
		database.ref("preguntas").on("value", snapshot => {
			let data = snapshot.val();
			this.props.llenarPreguntas(data.pregunta1, data.pregunta2);
		});
	}
	
	handleChange = (sParam, e) => {
		this.setState({[sParam]: e.target.value});
		this.validate(sParam,e.target.value);
	}
	
	toggle = (sParam) => {
		this.setState({[sParam]: !this.state[sParam]});
	}
	
	handleSelect = (sParam, e) => {
		this.setState({[sParam]: e});
	}
	
	viewPass = () => {
		this.setState({ showPass: !this.state.showPass });
	}

	viewPassConf = () => {
		this.setState({ showConfPass: !this.state.showConfPass });
	}

	viewPassResp1 = () => {
		this.setState({ showResp1: !this.state.showResp1 });
	}

	viewPassResp2 = () => {
		this.setState({ showResp2: !this.state.showResp2 });
	}
	
	state = {
		showPass: true,
		showConfPass: true,
		showResp1: true,
		showResp2: true,
		password: "",
		confPassword: "",
		respuesta1: "",
		respuesta2: "",
		pregunta1: 0,
		pregunta2: 0,
		validate : {
			password: false,
			confPassword: false,
			respuesta1: false,
			respuesta2: false
		},
		modalPassword: false,
		modalQuestions: false,
	}

	modalPass = () => {
		if(this.state.modalPassword) {
			this.setState({ modalPassword: false });
		} else {
			this.setState({ modalPassword: true });
		}
	}

	modalQuest = () => {
		if(this.state.modalQuestions) {
			this.setState({ modalQuestions: false });
		} else {
			this.setState({ modalQuestions: true });
		}
	}

	closeModalFromChild = () => {
		this.setState({ modalPassword: false });
	}

	closeModalFromChilds = () => {
		this.setState({ modalQuestions: false });
	}
	
	componentDidMount = () => {
		$(".pass, .confpass").bind("copy paste",function(e) { e.preventDefault(); return false; });
	}
	
	render() {
		const { handleSubmit } = this.props;
		
		return	(
			<form onSubmit={handleSubmit} className="remove-all-styles">
				<div className="container">
					<div className="margin-mobile">
						<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12">
								<div className="subtitle">
									Establecer contraseña 
									<img src={ require("../img/help_outline_24px.png") }  onClick={this.modalPass.bind(this)} />
								</div>
							</div>
						</div>
							
						<div className="row">
							<div className="col-md-6 col-sm-6 col-xs-12">
								<Field name="password" label="Contraseña" component={campo} max="24" type={this.state.showPass ? "password" : "text"} props={{param: this.state.showPass, fnToggle: this.toggle.bind(this, "showPass") }}/>
								<button type="button" className={this.state.showPass ? "eye-visible" : "eye-hidden"} onClick={() => {this.viewPass()}}></button>
							</div>
							<div className="col-md-6 col-sm-6 col-xs-12">
								<Field name="confpassword" label="Confirmar contraseña" component={campo} max="24" type={this.state.showConfPass ? "password" : "text"} props={{param:this.state.showConfPass, fnToggle: this.toggle.bind(this, "showConfPass"),clase:"confpass"}}/>
								<button type="button" className={this.state.showConfPass ? "eye-visible" : "eye-hidden"} onClick={() => {this.viewPassConf()}}></button>
							</div>
						</div>
						<div className="row">
							<div className="col-xs-12">
								<div className="subtitle">
									Preguntas Secretas 
									<img src={ require("../img/help_outline_24px.png") }  onClick={this.modalQuest.bind(this)} />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-6 col-sm-6 col-xs-12">
								<Field name="pregunta1" component={campoSelect} label="Pregunta 1">
									<option value="0">Selecciona una pregunta</option>
									{ this.props.preguntas1.map((item,i) =>
										<MenuItem value={item.id} key={i} primaryText={item.descripcion} />
									)}
								</Field>
							</div>
							<div className="col-md-6 col-sm-6 col-xs-12">
								<Field name="respuesta1" label="Respuesta 1" component={campo} type={this.state.showResp1 ? "password" : "text"} validate={espacios("respuesta1")} props={{param:this.state.showResp1, fnToggle: this.toggle.bind(this, "showResp1")}}/>
								<button type="button" className={this.state.showResp1 ? "eye-visible" : "eye-hidden"} onClick={() => {this.viewPassResp1()}}></button>
							</div>
						</div>
						<div className="row">
							<div className="col-md-6 col-sm-6 col-xs-12">
								<Field name="pregunta2" component={campoSelect} label="Pregunta 2">
									<option value="0">Selecciona una pregunta</option>
									{ this.props.preguntas2.map((item,i) =>
										<MenuItem value={item.id} key={i} primaryText={item.descripcion} />
									)}
								</Field>
							</div>
							<div className="col-md-6 col-sm-6 col-xs-12">
								<Field name="respuesta2" label="Respuesta 2" component={campo} type={this.state.showResp2 ? "password" : "text"} validate={espacios("respuesta2")} props={{param:this.state.showResp2, fnToggle: this.toggle.bind(this, "showResp2")}}/>
								<button type="button" className={this.state.showResp2 ? "eye-visible" : "eye-hidden"} onClick={() => {this.viewPassResp2()}}></button>
							</div>
						</div>
						<div className="row btn-bottoms" style={{marginBottom: "20px"}}>
							<div className="col-xs-12">
								<button
									className="orange-rectangle"
									type="submit"
									className="pure-material-button-contained btn-full-width">
										Continuar
								</button>
							</div>
						</div>
					</div>
				</div>
				{this.state.modalPassword &&
					<Modal closeModalFromChild={this.closeModalFromChild}>
						<div className="text-center mt-20">
							<h4 className="modal-title" id="modal-contrasenaLabel">Para tu nueva contraseña contempla que:</h4>
						</div>
						<div className="row">
							<div className="col-xs-12 mb-20">
								<div className="text-center">
									<ol>
										<li className="list-movil">Debe ser de al menos 8 posiciones, incluyendo caracteres alfanuméricos.</li>
										<li className="list-movil">No debe contener la palabra GNP.</li>
										<li className="list-movil">No debe contener más de dos caracteres iguales de forma consecutiva (p.e. 222, eee).</li>
										<li className="list-movil">No debe tener más de dos caracteres consecutivos numéricos o alfabéticos (p.e. 123, abc).</li>
										<li className="list-movil">Debe incluir al menos una letra mayuscula, una letra minuscula y un número.</li>
									</ol>
								</div>
								<div className="text-center aceptar-cancelar-btn mt-20">
									<a onClick={this.modalPass.bind(this)} className="orange-movil">Aceptar</a>
								</div>
							</div>
						</div>
					</Modal>
				}
				{this.state.modalQuestions &&
					<Modal closeModalFromChild={this.closeModalFromChilds}>
						<div className="text-center mt-20">
							<h4 className="modal-title" id="modal-preguntasLabel">Importante</h4>
						</div>
						<div className="row">
							<div className="col-xs-12 mb-20">
								<div className="text-center">
									<p>Las preguntas secretas te ayudarán a desbloquear tu contraseña en caso de olvido y también se te solicitarán para autorizar algunas transacciones, podrás utilizarlas en la aplicación Soy Cliente GNP.</p>
								</div>
								<div className="text-center aceptar-cancelar-btn mt-20">
									<a onClick={this.modalQuest.bind(this)} className="orange-movil">Aceptar</a>
								</div>
							</div>
						</div>
					</Modal>
				}
			</form>
		);
	}
}

SeguridadForm = reduxForm({
	form: "datosSeguridad",
	validate
})(SeguridadForm);

export default connect(mapState, mapDispatch)(SeguridadForm);


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/seguridad-movil.frm.js